import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconPlusLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M11.25 12.75h-6a.725.725 0 0 1-.534-.216A.726.726 0 0 1 4.5 12c0-.213.072-.391.216-.534a.725.725 0 0 1 .534-.216h6v-6c0-.213.072-.39.216-.534A.726.726 0 0 1 12 4.5c.213 0 .391.072.534.216a.725.725 0 0 1 .216.534v6h6c.212 0 .39.072.534.216A.726.726 0 0 1 19.5 12a.722.722 0 0 1-.216.534.726.726 0 0 1-.534.216h-6v6c0 .212-.072.39-.216.534A.726.726 0 0 1 12 19.5a.725.725 0 0 1-.534-.216.726.726 0 0 1-.216-.534v-6Z" />
    </Svg>
  );
};

export default IconPlusLine;
